import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { DEFAULT_CONTENT } from "./content-defaults";

export function useContent(sectionKey: keyof typeof DEFAULT_CONTENT) {
  const { data } = useQuery({
    queryKey: ["site_content", sectionKey],
    queryFn: () => api.content.get(sectionKey),
  });
  const override = (data && typeof data === "object" && !Array.isArray(data)) ? data : {};
  return { ...DEFAULT_CONTENT[sectionKey], ...override } as any;
}

export function useSettings() {
  const { data } = useQuery({
    queryKey: ["site_settings"],
    queryFn: () => api.settings.get(),
  });
  return data;
}
